.mfa-secondary {
    font-weight: normal;
    color: var(--grey-lt);
    font-size: var(--font-normal);
    line-height: 1.5;
    margin-top: 0;
    margin-bottom: 0;
}
